import theme from './theme';
import { getBrand } from '../utils/brand/getBrand';

export default (brand) => {
  const { brandId } = getBrand(brand);
  return theme(brandId);
};



// WEBPACK FOOTER //
// ./src/styles/index.js